import React, {Ref} from 'react';

const withForwardingRef = <Props extends {}, TRef = any>(
    BaseComponent: React.ComponentType<Props & {forwardedRef: Ref<TRef>}>
) => React.forwardRef<TRef, Props>((props, ref) => <BaseComponent {...props} forwardedRef={ref} />);

export default withForwardingRef;
